import routeList from '../router/routeList'
const pageIdConfig = {
  // 需要统计数据的路由列表
  routeList: routeList.filter(item => item.meta && item.meta.pageId)
    .map(item => {
      const result = {
        name: item.name || '',
        route: item.path,
        pageId: item.meta.pageId,
        level: item.meta.level
      }
      return result
    })
}
export default pageIdConfig